import { render, staticRenderFns } from "./PsHomeSubscriptions.vue?vue&type=template&id=1a36125a&scoped=true&"
import script from "./PsHomeSubscriptions.vue?vue&type=script&lang=js&"
export * from "./PsHomeSubscriptions.vue?vue&type=script&lang=js&"
import style0 from "./PsHomeSubscriptions.vue?vue&type=style&index=0&id=1a36125a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a36125a",
  null
  
)

export default component.exports